import React from 'react';
import { useSelector } from 'react-redux';

const FormConfirmacionVehiculo = () => {
    const vehiculo = useSelector(state => state.vehiculo);
    const {   stepWay } = useSelector(state => state.pasosReservacion);
    console.log("tipo de boton", stepWay);
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <img className="img-confirmacion" src={`${((vehiculo.EsLocal === 'Y') ? `${process.env.PUBLIC_URL}/images/` : ``)}${vehiculo.ImagenURL}`} alt="..." />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h1 className="cursive-bold">{vehiculo.Nombre}</h1>
                </div>
            </div>
        </>
    )
}

export default FormConfirmacionVehiculo
